import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function communicationInfoReducer(state = initialState.leadCommunicationInfo, action) {
  switch (action.type) {
    case types.LOAD_COMMUNICATON_INFO_SUCCESS:
      return action.leadCommunicationInfo;
    default:
      return state;
  }
}
